export const B2C = "B2C";
export const B2B = "B2B";
export const AUTH0 = "AUTH0";
export const BASIC = "BASIC";
